import { useMemo } from 'react';

import { areBetsEqual, countTotalBet, emptyBets, getNewBet } from '../../utils/bets';
import { useBetSlice } from '../slices/bets/selectors';
import type { BetType } from '../slices/bets/types';
import { useChipSlice } from '../slices/chips/selectors';
import { useGameStateSlice } from '../slices/game/selectors';

export const useBetOnAllEnabled = (): boolean => {
  const balance = useGameStateSlice.getDeductibleBalance();
  const betLimits = useBetSlice.betLimits();
  const bets = useBetSlice.bets();
  const decimals = useGameStateSlice.getCurrencyInfo()?.digitsNumber || 2;
  const tableLimit = useBetSlice.getTableLimits()?.max || Infinity;

  const selectedChip = useChipSlice.getSelectedChip();
  const betList = useBetSlice.betList();

  return useMemo(() => {
    if (!betList || !betLimits) {
      return false;
    }

    const changedBets = emptyBets();
    betList.forEach((betSpot) => {
      changedBets.betSpots[betSpot] = { value: selectedChip.value };
    });

    const currentBets: BetType = bets ?? emptyBets();
    const newBet = getNewBet(currentBets, changedBets, decimals, betLimits, betList, tableLimit, balance);
    if (!newBet) {
      return false;
    }

    const totalBet = countTotalBet(newBet.betSpots, decimals);

    return !areBetsEqual(newBet, currentBets) && balance >= totalBet && totalBet <= tableLimit;
  }, [balance, betLimits, betList, bets, decimals, selectedChip, tableLimit]);
};
